import createPersistedState from 'vuex-persistedstate'
import { createStore } from 'vuex'
//import auth from './auth'
import login from './modules/login'
import guide from './modules/guide'

const store = createStore({
    modules: {
        //auth,
        login,
        guide
    },
    plugins:
        [createPersistedState(
            {
                paths: ["login"]
            }
        )],
})

export default store